<div class="title" mat-dialog-title>Add a Moat Token</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your account manager to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Moat Token</mat-label>
                <input type="password" matInput placeholder="Enter Moat Token" formControlName="moatToken" data-cy="moat-token-input">
                <mat-error
                    *ngIf="connectionForm.get('moatToken').errors && (connectionForm.get('moatToken').touched || 
                    connectionForm.get('moatToken').dirty)">
                    Invalid Moat Token</mat-error>
            </mat-form-field>
        </form>
        <div class="template">
            <a href="https://rubii-images.s3.ap-southeast-2.amazonaws.com/templates/moat.xlsx"
                target="_blank" data-cy="moat-template-link">Download a sample report</a>
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="moat-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>
